<template>
<div id="consolidado_balluf" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="REPORTE FREIGHT ALLOCATION" class="elevation-1 px-5 py-3" >
                    <br>
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab key="consolidado">REPORTE</v-tab>
                        <v-tab key="checklist">CHECKLIST</v-tab>
                        
                        <v-tab-item key="consolidado" >
                            <br>
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4" >
                                        <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }" >
                                            <v-text-field v-on="on" v-model="model_busqueda.fecha_de" clearable label="Fecha Inicial Pedimento" color="secondary" prepend-icon="event" @blur="model_busqueda.fecha_de = parseDate(model_busqueda.fecha_de)" v-mask="'####-##-##'"
                                                :rules="[validaAnio, validaFecha, validaObligatorio]" ></v-text-field>
                                            </template>

                                            <v-date-picker v-model="model_busqueda.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu1 = false" >
                                                Cancelar
                                            </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4" >
                                        <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }" >
                                            <v-text-field v-on="on" v-model="model_busqueda.fecha_a" clearable label="Fecha Final Pedimento" color="secondary" prepend-icon="event" @blur="model_busqueda.fecha_a= parseDate(model_busqueda.fecha_a)" v-mask="'####-##-##'"
                                                :rules="[validaAnio, validaFecha, validaObligatorio]" ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="model_busqueda.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu2 = false" >
                                                Cancelar
                                            </v-btn>
                                            </v-date-picker>
                                        </v-menu>

                                        </v-col>
                                        <v-col sm="12" md="4" lg="4" >
                                            <v-text-field v-model="model_busqueda.pedimento" clearable label="No Pedimento"
                                                hint="Ejemplo: 123-1234-1234567" persistent-hint
                                                :rules="[validaObligatorio,validaPatronPedimento]"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="success" @click="generar_reporte_sqs()" >
                                    <v-icon>done</v-icon>Generar Reporte
                                </v-btn>                                
                            </v-card-actions>
                            </v-card-text>
                            

                            <v-card-text>
                                <v-refresh-button :funcion="cargar" />
                                <v-client-table ref="vuetable" :data="datos" :columns="columns_reportes" :options="options_reportes" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>
                                </v-client-table>
                            </v-card-text>


                        </v-tab-item>
                        <v-tab-item key="checklist" >
                            <div class="contenedor-tab-reportes" >
                                <v-card-text>
                                <v-card-title>
                                    <span class="headline" ></span>
                                </v-card-title>
                                
                                </v-card-text>
                                
                                <v-card-text>
                                    <v-row>
                                        <v-col sm="3" md="3" lg="3" >
                                            1.- Descargar Layout Checklist:
                                        </v-col>
                                        <v-col sm="1" md="1" lg="1" >
                                            <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="Layout_Checklist.xlsx" >
                                            <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                                <v-icon dark>receipt</v-icon>
                                            </v-btn>
                                        </exportar-excel>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col sm="3" md="3" lg="3" >
                                            2.- Carga de Checklist:
                                        </v-col>
                                        <v-col sm="1" md="1" lg="1" >
                                            <upload-excel-component idInput="pedimentosKey" :firstRow="4" :on-success="handleSuccess" :before-upload="beforeUpload" />
                                        </v-col>
                                    </v-row>
                                        
                                
                                </v-card-text>

                                <v-card-text>
                                    
                                    <v-refresh-button :funcion="cargarChecklist" />
                                    <v-client-table ref="vuetable" :data="datos_checklist" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="success" title="Checklist" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                                            <v-icon dark>mdi-file-excel</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="warning" title="Volver a Validar" @click="revalidar(props.row.id)" >
                                            <v-icon dark>refresh</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="red" title="Eliminar" @click="eliminarChecklist(props.row.id, props.row.nombre_checklist)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>
                                    </v-client-table>
                                </v-card-text>

                            </div>     
                        </v-tab-item>
                        
                    </v-tabs>                                                                   
                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>


</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

window.html2canvas = html2canvas
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },

data: () => ({
        file_adjunto: null,
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        URL:"",        
        data_resumen:[],
        
        permisoEliminar: false,
        menu1: false,
        menu2: false,
        modal:false,
        model_busqueda:{
            rfc: "",
            usuario: "",
            fecha_de:"",
            fecha_a:"",
            pedimento:"",            
            reporte_url: "/reportes_ws/consolidado_balluf/",
            nombre_reporte: "Consolidado Finanzas",
            tipo: "Consolidado Finanzas Balluf",
        },
        name: "datagrid",
        importData: [],
        arrClaves:[],        
        URL: "",

        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Reportes",
                disabled: true,
                to: ""
            },
            {
                text: "Freight Allocation",
                disabled: true,
                to: ""
            }
        ],
        datos: [],
        datos_checklist: [],
        columns_reportes:["id","fecha_solicitud", "usuario_email", "criterio", "fecha_generacion", "estatus", "error", "actions"],
        options_reportes: {
            filterable: ["id","fecha_solicitud", "usuario_email", "criterio", "fecha_generacion", "estatus", "error"],
            sortable: ["id","fecha_solicitud", "usuario_email", "criterio", "fecha_generacion", "estatus", "error"],

            headings: {
                id:"No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",                
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Opciones"
            }
        },

        columns: ["nombre_checklist", "fecha_solicitud", "iniciales", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["nombre_checklist", "fecha_solicitud", "iniciales", "fecha_generacion", "estatus", "error"],
            sortable: ["nombre_checklist", "fecha_solicitud", "iniciales", "fecha_generacion", "estatus", "error"],

            headings: {
                nombre_checklist: "Nombre Checklist",
                fecha_solicitud: "Solicitado",
                iniciales: "Usuario",                 
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Opciones"
            }
        },
        
        encabezadoLayout: {
            "No Guía/Tracking Number": "No Guía/Tracking Number",
            "Contribuciones":"Contribuciones",     
            "Flete internacional":"Flete internacional",
            "Seguro":"Seguro",
            "Agente Aduanal":"Agente Aduanal",
            "Gasto de terceros":"Gasto de terceros",
            "NOMS":"NOMS",
            "Flete nacional":"Flete nacional",
            "Gastos en destino":"Gastos en destino",
        },
        
        camposLayout: [{
            "No Guía/Tracking Number": "",
            "Contribuciones":"BI3 - Other services",
            "Flete internacional":"BI1 - International Freight",
            "Seguro":"BI2 - Insurance",
            "Agente Aduanal":"BB1 - Brokerage",
            "Gasto de terceros":"BB2 - Third party",
            "NOMS":"BN2 - NOMS",
            "Flete nacional":"BN1 - National freight",
            "Gastos en destino":"BN3 - Destination fees",
        },{             
            "No Guía/Tracking Number": "[No de Guía o Tracking Number]",
            "Contribuciones":"[Agregar SI o NO (SI aplica o NO applica)]",
            "Flete internacional":"[Agregar SI o NO]",
            "Seguro":"[SI|NO]",
            "Agente Aduanal":"[SI|NO]",
            "Gasto de terceros":"[SI|NO]",
            "NOMS":"[SI|NO]",
            "Flete nacional":"[SI|NO]",
            "Gastos en destino":"[SI|NO]",
        }, {
            "No Guía/Tracking Number": "Agregar información a partir de esta fila (4ta fila)",
        }],
        camposObligatorios: [
            "No Guía/Tracking Number",
            "Contribuciones",
            "Flete internacional",
            "Seguro",
            "Agente Aduanal",
            "Gasto de terceros",
            "NOMS",
            "Flete nacional",
            "Gastos en destino",
        ],        
    }),
    methods: {
        validaFecha: function(fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida."
            else
                return true;
        },
        validaAnio: function() {
            if (this.model_busqueda.fecha_de != "" && this.model_busqueda.fecha_a != "") {
                var inicio = moment(this.model_busqueda.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model_busqueda.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                return "La Fecha Final no debe ser menor a la Fecha Inicial."
            }
            return true;
        },
        validaObligatorio: function(){
            if ((this.model_busqueda.pedimento == null || this.model_busqueda.pedimento == "") && (this.model_busqueda.fecha_de == "" || this.model_busqueda.fecha_a == "" || this.model_busqueda.fecha_de == null || this.model_busqueda.fecha_a == null)) {
                return "Debe ingresar un rango de fechas o un pedimento.";
            }
            return true;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        
        beforeUpload(file) {
            var self = this;
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                self.file_adjunto = file;
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            self.file_adjunto = null;
            return false;
        },

        validaPatronPedimento: function(val){
            if(val && val!="" && !this.validarPatronPedimento(val)){
                return "Pedimento no válido";                
            }
            return true;
        },
        validarPatronPedimento(pedimento){
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },        
        validaEntero(numero){
            const pattern = /^[\d]*$/;
            return pattern.test(numero);
        },
     
        
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
                
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 500){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 500, favor de verificar.";
                } else {
                    for (var k in results) {                                                

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {
                            
                            if(results[k]['Contribuciones'] != undefined){
                                results[k]['Contribuciones'] = results[k]['Contribuciones'].toString().trim().toUpperCase();
                                if(!["SI","NO"].includes(results[k]['Contribuciones'])){
                                    errores++;
                                    errorTmp = '<br/>' + "- Contribuciones debe ser SI o NO";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;    
                                }
                            }
                            if(results[k]['Flete internacional'] != undefined){
                                results[k]['Flete internacional'] = results[k]['Flete internacional'].toString().trim().toUpperCase();
                                if(!["SI","NO"].includes(results[k]['Flete internacional'])){
                                    errores++;
                                    errorTmp = '<br/>' + "- Flete internacional debe ser SI o NO";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;    
                                }
                            }
                            if(results[k]['Seguro'] != undefined){
                                results[k]['Seguro'] = results[k]['Seguro'].toString().trim().toUpperCase();
                                if(!["SI","NO"].includes(results[k]['Seguro'])){
                                    errores++;
                                    errorTmp = '<br/>' + "- Seguro debe ser SI o NO";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;    
                                }
                            }
                            if(results[k]['Agente Aduanal'] != undefined){
                                results[k]['Agente Aduanal'] = results[k]['Agente Aduanal'].toString().trim().toUpperCase();
                                if(!["SI","NO"].includes(results[k]['Agente Aduanal'])){
                                    errores++;
                                    errorTmp = '<br/>' + "- Agente Aduanal debe ser SI o NO";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;    
                                }
                            }
                            if(results[k]['Gasto de terceros'] != undefined){
                                results[k]['Gasto de terceros'] = results[k]['Gasto de terceros'].toString().trim().toUpperCase();
                                if(!["SI","NO"].includes(results[k]['Gasto de terceros'])){
                                    errores++;
                                    errorTmp = '<br/>' + "- Gasto de terceros debe ser SI o NO";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;    
                                }
                            }
                            if(results[k]['NOMS'] != undefined){
                                results[k]['NOMS'] = results[k]['NOMS'].toString().trim().toUpperCase();
                                if(!["SI","NO"].includes(results[k]['NOMS'])){
                                    errores++;
                                    errorTmp = '<br/>' + "- NOMS debe ser SI o NO";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;    
                                }
                            }
                            if(results[k]['Flete nacional'] != undefined){
                                results[k]['Flete nacional'] = results[k]['Flete nacional'].toString().trim().toUpperCase();
                                if(!["SI","NO"].includes(results[k]['Flete nacional'])){
                                    errores++;
                                    errorTmp = '<br/>' + "- Flete nacional debe ser SI o NO";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;    
                                }
                            }
                            if(results[k]['Gastos en destino'] != undefined){
                                results[k]['Gastos en destino'] = results[k]['Gastos en destino'].toString().trim().toUpperCase();
                                if(!["SI","NO"].includes(results[k]['Gastos en destino'])){
                                    errores++;
                                    errorTmp = '<br/>' + "- Gastos en destino debe ser SI o NO";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;    
                                }
                            }
                            

                        }
                        
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {            
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {                
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                    for (var k in results) {
                        this.importData.push({
                            no_guia: results[k]['No Guía/Tracking Number'].toString().trim(),
                            contribuciones: results[k]['Contribuciones'].toString().trim().toUpperCase(),
                            flete_internacional: results[k]['Flete internacional'].toString().trim().toUpperCase(),
                            seguro: results[k]['Seguro'].toString().trim().toUpperCase(),
                            agente_aduanal: results[k]['Agente Aduanal'].toString().trim().toUpperCase(),
                            gasto_terceros: results[k]['Gasto de terceros'].toString().trim().toUpperCase(),
                            noms: results[k]['NOMS'].toString().trim().toUpperCase(),
                            flete_nacional: results[k]['Flete nacional'].toString().trim().toUpperCase(),
                            gasto_destino: results[k]['Gastos en destino'].toString().trim().toUpperCase(),                            
                        });
                    }
                    var datos = {
                        rfc: this.$local_storage.get("rfc"),
                        checklist: this.importData,
                        nombre_checklist: this.file_adjunto.name,
                        usuario: this.$local_storage.get("id_usuario"),
                    }                    
                    
                    axios.post(this.$apiReportes + "reportes_ws/save_checklist_balluf/", datos)                    
                        .then((res) => {

                            var data2 = {
                                "rfc":this.$local_storage.get("rfc"),
                                "id_checklist": res.data.id
                            };
                            axios.post(this.$apiReportes + "reportes_ws/valida_checklist_balluf/", data2)                            
                                .then((res) => {

                                    this.$swal({
                                        type: "success",
                                        title: "Operación Exitosa",
                                        text: "La validación se realizó correctamente. Puede descargar el checklist en las opciones del registro",
                                        footer: ""
                                    });
                                                                
                                })
                                .catch(err => {
                                    this.$swal({
                                        type: "error",
                                        title: "¡Operación no Permitida!",
                                        text: "Ocurrió un error al validar checklist. Favor de intentar nuevamente en la opción de Volver a Validar.",
                                        footer: ""
                                    });                                    
                                }).then(()=>{
                                    this.$root.$dialogLoader.hide();                                
                                    this.cargarChecklist();
                                });
                            
                                                        
                        })
                        .catch(err => {
                            console.log(err);
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de intentar nuevamente.",
                                footer: err
                            });
                            this.$root.$dialogLoader.hide();
                            this.cargarChecklist();
                        });
                    
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        }, 

        revalidar: function(id_checklist){
            var data2 = {
                "rfc":this.$local_storage.get("rfc"),
                "id_checklist": id_checklist
            };
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            axios.post(this.$apiReportes + "reportes_ws/valida_checklist_balluf/", data2)            
                .then((res) => {

                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "La validación se realizó correctamente. Puede descargar el checklist en las opciones del registro",
                        footer: ""
                    });
                                                
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al validar checklist. Favor de intentar nuevamente en la opción de Volver a Validar.",
                        footer: ""
                    });                                    
                }).then(()=>{
                    this.$root.$dialogLoader.hide();                                
                    this.cargarChecklist();
                });
        },

        guardar_plantilla_s3: function(id_etiqueta){
            var self = this;
            var rfc = this.$local_storage.get("rfc"); 
            var keyFile = rfc + "/plantillas_activo_fijo/"+ id_etiqueta.toString() + "_"+ self.file_adjunto.name;
                    
            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: self.file_adjunto.type
            }
            axios.post(self.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, self.file_adjunto, {headers:{'Content-Type': self.file_adjunto.type}})
                        .then((res) => { 
                            console.log("Archivo cargado correctamente a S3");
                        })                            
                        .catch((error)=>{                                                        
                            console.log("Error al cargar a S3: ", error);
                        });
                        
                    } else {
                        console.log("Undefined url de carga S3: ", res.data);
                    }
                })
                .catch((error) => {
                    console.log("Error al obtener url de carga S3: ", error);
            });
        },

        cargar: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.$local_storage.get('rfc'),
                tipo: 'Consolidado Finanzas Balluf'
            };
            axios.post(this.URL + "get_reportes/", data)
            .then(res => {
            if (typeof res.data !== "undefined") {
                this.datos = res.data;
                this.datos.sort(function(a, b) {
                    //Ordenar por fecha más reciente
                    return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                });
                for (var k in this.datos) {                    
                    this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                    this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                    this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);   
                    this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);                 
                }
            }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los registros. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
        },
        getCriterioPredeterminadosDS: function(criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    var result = ""
                    if (params.pedimento != "")
                        result += "\nPedimento: " + params.pedimento;
                    else {
                        result += "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    }
                    return result;
                } else {
                    return "N/A";
                }
            } catch (error) {
                    console.log(error);
                    return "N/A-error";
            }
        },
        cargarChecklist: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.$local_storage.get('rfc')                
            };            
            axios.post(this.$apiReportes + "reportes_ws/get_checklist_balluf/", data)            
            .then(res => {
            if (typeof res.data !== "undefined") {
                this.datos_checklist = res.data;
                this.datos_checklist.sort(function(a, b) {
                    //Ordenar por fecha más reciente
                    return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                });
                for (var k in this.datos_checklist) {                    
                    this.datos_checklist[k].fecha_solicitud = this.parseDate(this.datos_checklist[k].fecha_solicitud);
                    this.datos_checklist[k].fecha_generacion = this.parseDate(this.datos_checklist[k].fecha_generacion);
                    this.datos_checklist[k].estatus = this.getEstatus(this.datos_checklist[k].estatus);                    
                }
            }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los registros. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
        },
        getEstatus: function(estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        eliminarChecklist: function (id_checklist, nombre) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el checklist: "+nombre+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    rfc: this.$local_storage.get("rfc"),
                    id_checklist: id_checklist,
                };
                axios.post(this.$apiReportes + "reportes_ws/delete_checklist_balluf/", datos)                
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro. Intente nuevamente por favor.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargarChecklist();                        
                    });
              }
          });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();                        
                    });
              }
          });
        },
        downloadReporte: function(key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                if (typeof res.data !== 'undefined') {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = res.data.mensaje;
                    a.target = '_blank';
                    a.click();
                    a.parentNode.removeChild(a);

                } else {
                    this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                    footer: '',
                    });
                }
                })
                .catch((error) => {
                var mensaje = "Ocurrió un error al descargar el archivo";
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                    mensaje = error.response.data.mensaje;
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: mensaje,
                    footer: '',
                });
                console.log(error);
                }).then(() => {
                this.$root.$dialogLoader.hide();
                });
            },

            
            generar_reporte_sqs() {
                if (!this.$refs.form.validate()) {
                    //Alguna operación o mensaje
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var data = this.model_busqueda;                               

                    data["id_reporte"] = 999999;
                    
                    axios({
                            method: "post",
                            url: this.$hostname + "reportes/save_reporte/",
                            //url: "http://127.0.0.1:7000/reportes_ws/consolidado_balluf/",
                            data: data
                        })
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                                footer: ""
                            });
                        })
                        .catch(error => {
                            let mensaje;
                            var titulo = "¡Operación no Permitida!";
                            var tipo = "error";
                            if (typeof error.response !== "undefined") {
                                mensaje = error.response.data.mensaje;
                                if (error.response.status == 406){
                                    titulo = "¡Ya existe un reporte en proceso!";
                                    tipo = "info";
                                }
                            } else {
                                mensaje = "Ocurrió un error al generar el reporte";
                            }
                            this.$swal({
                                type: tipo,
                                title: titulo,
                                text: mensaje,
                                footer: ""
                            });
                        }).then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                }
            },
            
        
    }, //methods

    created: function () {    
        this.URL = this.$hostname+"reportes/";
        this.model_busqueda.usuario = this.$local_storage.get("id_usuario");
        this.model_busqueda.rfc = this.$local_storage.get("rfc");
        this.cargar();      
        this.cargarChecklist();

    }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }    

</style>
